import axios from 'axios';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import ShashiUnpluggedGuest from './ShashiUnpluggedGuest';

function ShashiUnpluggedOpenGuest() {
  const { token, isPin } = useParams();
  useEffect(() => {
    if (!token) return;

    // 1. Try opening the app
    const deepLink = `ShashiApp://?pin=${encodeURIComponent(token)}`;
    window.location.href = deepLink;

    // 2. Fallback: get store URL from backend if app not installed
    const timer = setTimeout(() => {
      axios.post(`${process.env.REACT_APP_RESERVATION}/v1/magic-link-session/start-session`, {
        'app-token': token,
      }).then((res) => {
        const storeUrl = res.data?.result?.data?.storeUrl;
        if (res.data?.result?.data?.storeUrl) {
          window.open(res.data?.result?.data?.storeUrl, '_self');
        }
      }).catch((err) => {
        alert(err?.response?.data?.result?.message || 'Something went wrong');
      });
    }, 1200); // wait 1.2s so app has chance to open first

    return () => clearTimeout(timer);
  }, [token]);
  return (
    <div>
      <ShashiUnpluggedGuest token={token} />
    </div>
  );
}

export default ShashiUnpluggedOpenGuest;
